module.exports = __webpack_public_path__ + "263f5cb5709697e2fb0d1e17a12b304e.png";